import React from 'react';
import EmptyState from './EmptyState';

export default function MvResult({ mv, t, cost, onRegenerate }) {
  if (!mv) {
    return (
      <EmptyState
        type="video"
        title={t('videoGeneration.mv.preview.emptyMvTitle')}
        desc={t('videoGeneration.mv.preview.emptyMv')}
        hint={t('videoGeneration.mv.preview.emptyMvHint')}
      />
    );
  }
  const onDownload = () => {
    if (mv.downloadUrl || mv.videoUrl) {
      window.open(mv.downloadUrl || mv.videoUrl, '_blank', 'noopener');
    }
  };
  return (
    <div className="mv-result mv-result--video">
      <div className="mv-video">
        <div className="mv-video__screen">MV</div>
        <div className="mv-video__copy">
          <strong>{mv.title}</strong>
          <span>{t('videoGeneration.mv.preview.mvPlaceholder')}</span>
        </div>
      </div>
      <div className="mv-next">
        <div><strong>{t('videoGeneration.mv.preview.mvTitle')}</strong><span>{mv.meta}</span></div>
        <div className="mv-actions">
          <button onClick={onRegenerate}>{t('videoGeneration.mv.actions.regenerateWithCredits', { count: cost })}</button>
          <button disabled={!mv.downloadUrl && !mv.videoUrl} onClick={onDownload}>{t('videoGeneration.mv.actions.download')}</button>
        </div>
      </div>
    </div>
  );
}
